import { useHoverPopoverClose } from '@app/components/base/HoverPopover';
import { AuditLiveMention } from '@app/modules/audit/modules/station-audit/types';
import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { toTimestamp } from '@mi-front/core';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type MentionTime = {
  start: string | number | Date;
  end: string | number | Date;
};

/**
 * Checks whether custom mention data contains a usable time range.
 */
function isMentionTime(value: unknown): value is MentionTime {
  if (typeof value !== 'object' || value === null || value instanceof Date) {
    return false;
  }

  const time = value as Record<string, unknown>;
  return (
    (typeof time.start === 'string' ||
      typeof time.start === 'number' ||
      time.start instanceof Date) &&
    (typeof time.end === 'string' || typeof time.end === 'number' || time.end instanceof Date)
  );
}

/**
 * Selects and reveals the detected mention range in the stream.
 */
export function MentionShowButton({ liveMention }: { liveMention: AuditLiveMention }) {
  const { setSelection } = useStreamSelection();
  const closePopover = useHoverPopoverClose();
  const mentionTime = liveMention.customData?.time;

  if (!isMentionTime(mentionTime)) {
    return null;
  }

  const handleShow = () => {
    setSelection(toTimestamp(mentionTime.start), toTimestamp(mentionTime.end));
    closePopover?.();
  };

  return (
    <Tooltip
      title={
        <FormattedMessage id="logger.liveMentions.showMention" defaultMessage="Mostrar mención" />
      }
      placement="top"
    >
      <IconButton size="small" color="secondary" onClick={handleShow}>
        <VisibilityIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
